export default __webpack_public_path__ + "static/media/evolve-3-0.92045ef1.png";